<script>
import {mapState} from 'vuex'

export default {
  name: 'SSOButton',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    link: {
      type: String,
      required: true,
    },

    type: {
      type: String,
      required: false,
      default: 'OTHERS'
    }
  },

  computed: mapState({
    isLoading: 'isLoading',
  }),

  methods: {
    redirect: function (event) {
      if (event) {
        event.preventDefault()
      }
      window.location.href = this.link
    },
    getImageName(type){
      switch (type) {
        case "MICROSOFT":
          return 'microsoft.svg';
        case "FACEBOOK":
          return 'facebook.svg';
        case "GOOGLE":
          return 'google.svg';
        default:
          return 'others.svg';
      }
    },
  }
}
</script>

<template>
  <div>
    <button
      v-if="visible"
      class="inv-btn submit-button"
      @click="redirect"
    >
      <img
        :src="require(`@/assets/${getImageName(type)}`)"
        class="submit-button__icon"
      />
      <slot
        class="submit-button__text"
      />

    </button>
  </div>
</template>

<style scoped>
.submit-button {
  width: 100%;
  margin-top: 10px;
  min-height: 40px;
  background-color: #ffffff;
  box-shadow: none;
  border: 1px solid #4693F8;
  color: #4693F8;
}

.submit-button__icon {
  margin-right: var(--space-8);
  width: 24px;
  height: 24px;
}

</style>